var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reaction-popup"},[_c('button',[_vm._v("😄")]),_c('ReactionPopupMenu',{attrs:{"id":_vm.id},on:{"on-redraw":function($event){return _vm.$emit('on-redraw')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }